import { unpackAndExtendSearch } from "../../utils/urlHelper";

export const getKundeBackNavigationTarget = (back, params = {}) => back
    ? unpackAndExtendSearch(back, { ...params, refresh: true })
    : {
        pathname: "/",
        search: "?" + new URLSearchParams({ ...params, refresh: true }).toString(),
    };
